if (!customElements.get("product-gallery-modal")) {
  customElements.define("product-gallery-modal", class ProductGalleryModal extends ModalDialog {
    constructor() {
      super();
      this.slider = this.querySelector("slider-component");
      this.tip = this.querySelector(".modal-tip");
      this.motionQuery = matchMedia("(max-width: 767px) and (prefers-reduced-motion: no-preference)");
      this.motionSequence = 0;
      this.motionQuery.addEventListener("change", () => this.clearMotion());
    }

    clearMotion() {
      this.motionSequence++;
      clearTimeout(this.openTimer);
      if (this.flight) this.flight.cancel();
      if (this.flightImage) this.flightImage.remove();
      if (this.flightTarget) this.flightTarget.style.visibility = this.targetVisibility || "";
      this.flight = null;
      this.flightImage = null;
      this.flightTarget = null;
    }

    paintedBox(image) {
      if (!image || !image.complete || !image.naturalWidth) return null;
      const box = image.getBoundingClientRect();
      if (!box.width || !box.height) return null;
      const scale = Math.min(box.width / image.naturalWidth, box.height / image.naturalHeight);
      const width = image.naturalWidth * scale;
      const height = image.naturalHeight * scale;
      return {left:box.left+(box.width-width)/2,top:box.top+(box.height-height)/2,width,height};
    }

    fly(image, from, to, hiddenTarget) {
      if (!this.motionQuery.matches || !from || !to || !Element.prototype.animate) return;
      const ghost = document.createElement("img");
      ghost.src = image.currentSrc || image.src;
      ghost.alt = "";
      ghost.setAttribute("aria-hidden", "true");
      ghost.className = "pk-media-flight";
      Object.assign(ghost.style,{position:"fixed",left:to.left+"px",top:to.top+"px",width:to.width+"px",height:to.height+"px",maxWidth:"none",objectFit:"contain",pointerEvents:"none",zIndex:"12031",transformOrigin:"0 0"});
      this.flightImage = ghost;
      if (hiddenTarget) {
        this.flightTarget = hiddenTarget;
        this.targetVisibility = hiddenTarget.style.visibility;
        hiddenTarget.style.visibility = "hidden";
      }
      document.body.appendChild(ghost);
      const scale = from.width / to.width;
      const transform = `translate(${from.left-to.left}px,${from.top-to.top}px) scale(${scale})`;
      this.flight = ghost.animate([{transform},{transform:"none"}],{duration:220,easing:"cubic-bezier(.2,.8,.2,1)"});
      const flight = this.flight;
      flight.finished.then(() => { if (this.flight === flight) this.clearMotion(); }, () => {});
    }

    sourceImage(opener) {
      return opener && opener.closest(".product-media-item,li")?.querySelector("img");
    }

    show(opener) {
      this.clearMotion();
      const source = this.sourceImage(opener);
      const from = this.paintedBox(source);
      super.show(opener);
      const sequence = this.motionSequence;
      this.openTimer = setTimeout(() => {
        if (!this.hasAttribute("open") || sequence !== this.motionSequence) return;
        const slide = this.showActiveMedia();
        requestAnimationFrame(() => {
          if (!this.hasAttribute("open") || sequence !== this.motionSequence) return;
          const image = slide?.querySelector("img");
          this.fly(image, from, this.paintedBox(image), image);
        });
      }, 50);
      clearTimeout(this.timer);
      if (this.tip) {
        this.tip.classList.add("active");
        this.timer = setTimeout(() => this.tip.classList.remove("active"), 5000);
      }
    }

    hide() {
      this.clearMotion();
      clearTimeout(this.timer);
      const active = this.slider?.sliderItems?.[this.slider.index];
      const mediaId = this.openedBy?.getAttribute("data-media-id");
      const sameMedia = active?.getAttribute("data-media-id") === mediaId;
      const image = sameMedia ? active.querySelector("img") : null;
      const from = this.paintedBox(image);
      const source = this.sourceImage(this.openedBy);
      const to = this.paintedBox(source);
      super.hide();
      if (from && to && to.top >= 0 && to.top < innerHeight) this.fly(image, from, to, null);
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute("data-media-id");
      if (!mediaId || !this.slider?.initSliderStatus) return null;
      const slide = this.slider.querySelector(`.slider-slide[data-media-id='${mediaId}']`);
      if (!slide) return null;
      this.slider.slideByElement(slide, true);
      const media = slide.querySelector(".deferred-media");
      if (media) media.loadContent();
      return slide;
    }
  });
}
